import React from 'react'

const ModelsLoader = () => {
  return (
    <div className="models-component-container mt-4 animate-pulse">
      {/* Cards Grid Skeleton */}
      <div className="grid grid-cols-1 h-full mb-20 xs:grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5 gap-x-6 gap-y-12">
        {Array.from({ length: 20 }, (_, index) => (
          <div key={index} className="flex  flex-col ai-card animate-pulse">
            <div className="relative w-full rounded-xl shadow-md bg-white border border-purple-100/50 overflow-hidden">
              {/* Image placeholder */}
              <div className="w-full aspect-video bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-shimmer"></div>

              {/* Overlay buttons */}
              <div className="absolute top-2 right-2 w-7 h-7 rounded-full bg-gray-300"></div>
              <div className="absolute bottom-2 left-2 w-10 h-5 rounded-full bg-gray-300"></div>
              <div className="absolute bottom-2 right-2 w-10 h-5 rounded-full bg-gray-300"></div>
            </div>

            <div className="mt-4 space-y-3 px-1">
              {/* Title placeholder */}
              <div className="h-5 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-shimmer rounded w-3/4"></div>

              {/* Description placeholder */}
              <div className="h-4 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-shimmer rounded w-full"></div>

              {/* Action buttons placeholder */}
              <div className="flex items-center justify-between w-full pt-1">
                <div className="h-8 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-shimmer rounded w-16"></div>
                <div className="h-8 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-shimmer rounded w-12"></div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <style>{`
        @keyframes shimmer {
          0% {
            background-position: -200% 0;
          }
          100% {
            background-position: 200% 0;
          }
        }
        .animate-shimmer {
          animation: shimmer 2s infinite linear;
        }
      `}</style>
    </div>
  )
}

export default ModelsLoader
